import { numberFormatDefaultLocale, numberFormatLocale, resetNumberFormatDefaultLocale } from './number';
import { resetTimeFormatDefaultLocale, timeFormatDefaultLocale, timeFormatLocale } from './time';
import { error, extend } from 'vega-util';

var createLocale = function createLocale(number, time) {
  return extend({}, number, time);
};

export function locale(numberSpec, timeSpec) {
  var number = numberSpec ? numberFormatLocale(numberSpec) : numberFormatDefaultLocale();
  var time = timeSpec ? timeFormatLocale(timeSpec) : timeFormatDefaultLocale();
  return createLocale(number, time);
}
export function defaultLocale(numberSpec, timeSpec) {
  var args = arguments.length;

  if (args && args !== 2) {
    error('defaultLocale expects either zero or two arguments.');
  }

  return args ? createLocale(numberFormatDefaultLocale(numberSpec), timeFormatDefaultLocale(timeSpec)) : createLocale(numberFormatDefaultLocale(), timeFormatDefaultLocale());
}
export function resetDefaultLocale() {
  resetNumberFormatDefaultLocale();
  resetTimeFormatDefaultLocale();
  return defaultLocale();
}